import { Component, OnInit, ViewEncapsulation, Renderer2, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { CustomerService } from '@app/cp/shared/services/customer.service';
import { Subscription } from 'rxjs';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { BaseMessageInfo } from '../../../shared/models/BaseMessageInfo';
import { DQOIService } from '../../../shared/services/DQOI.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SaveMode } from '../../../shared/enums/SaveMode';
import { BaseGridEditLineComponent } from '../../../shared/base-components/base-grid-editline.component';
import { InventoryService } from '../../../shared/services/inventory.service';
import { v_InventoryPriceByMonthDetailBus } from '../../../shared/models/v_InventoryPriceByMonthDetailBus';
import { DateFunctions } from '../../../shared/static/date-functions';
import { InventoryCostAdjustments } from '../../../shared/models/InventoryCostAdjustmentsBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'parts-cost-history-detail',
    templateUrl: './parts-cost-history-detail.component.html',
    styleUrls: ['./parts-cost-history-detail.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PartsCostHistoryDetailComponent extends BaseGridEditLineComponent<v_InventoryPriceByMonthDetailBus, null, InventoryService> implements OnInit, OnDestroy  {
    //dispatchStatusNameCF: MSCLFilterClass;
    //locationNameCF: MSCLFilterClass;
    //priorityNameCF: MSCLFilterClass;

    constructor(svc_data: InventoryService, globals: GlobalsService, private svc_cust: CustomerService, private qry_rd: DQOIReferenceDataQuery, private sanitizer: DomSanitizer, private activatedRoute: ActivatedRoute, renderer: Renderer2, cd: ChangeDetectorRef, private svc_dqoi: DQOIService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "v_InventoryPriceByMonthDetailBus";
        this.appCode = "InventoryCostHistoryDetailBus";
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            this.referenceData = data;
        });
        this.saveMode = SaveMode.individual;
        //this.setSelectableSettings();
    }
    subs_dataRef: Subscription;
    subs_dataRefUpdated: Subscription;

    override ngOnDestroy() {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }
    adjustFormActive: boolean = false;
    createForm() {
        this.editForm = new FormGroup({
            'adjustedQuantity': new FormControl('', Validators.required),
            'reason': new FormControl('', Validators.required),
            'orderReceiveDetailId': new FormControl(),
            'inventoryCostAdjustmentId': new FormControl(),
        });
    }
    setForm() {
        this.editForm.patchValue({
            adjustedQuantity: this.selectedData.adjustedQuantity,
            reason: this.selectedData.reason,
            orderReceiveDetailId: this.selectedData.orderReceiveDetailId,
            inventoryCostAdjustmentId: this.selectedData.inventoryCostAdjustmentId
        });
    }

    doCostAdjustment(data: v_InventoryPriceByMonthDetailBus) {
        this.selectedData = data;
        //if (!CommonFunctions.hasGuidValue(data.adjustmentUserId)) {
        //   // this.selectedData.adjustmentName = this.personFromUserId(this.globals.userId).empName;
        //}
        this.createForm();
        this.setForm();
        this.adjustFormActive = true;
    }
    //formTitle: string = "Add/Edit"
    closeForm() {
        this.adjustFormActive = false;
    }
    cancelForm() {
        this.adjustFormActive = false;
    }
    saveForm() {
        let dataObj: InventoryCostAdjustments = new InventoryCostAdjustments(null);
        dataObj.inventoryCostAdjustmentId = this.selectedData.inventoryCostAdjustmentId;
        dataObj.orderReceiveDetailId = this.selectedData.orderReceiveDetailId;
        dataObj.quantity = this.editForm.value.adjustedQuantity;
        dataObj.reason = this.editForm.value.reason;
        dataObj.setCommon(this.globals.userId, DateFunctions.getDateNow());
        dataObj.setBeforeSave();
        console.log("pchd->saveForm: ", this.selectedData, dataObj, this.editForm.value)
        this.svc_data.inventoryCostAdjustment_Save(dataObj).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError && info.primaryReturn) {
                let retDataObj: InventoryCostAdjustments = new InventoryCostAdjustments(info.primaryReturn);
                this.selectedData.adjustedQuantity = retDataObj.quantity;
                this.selectedData.reason = retDataObj.reason;
                this.selectedData.inventoryCostAdjustmentId = retDataObj.inventoryCostAdjustmentId;
                this.selectedData.orderReceiveDetailId = retDataObj.orderReceiveDetailId;
                this.notify("Adjustment Successfully Saved!");
            }
            else {
                this.notify("Problem Saving Adjustment: " + info.message,"E");
            }
            //this.selectedData.inventoryCostAdjustmentId
        });
        this.closeForm();
    }

    deleteIndividual(data: v_InventoryPriceByMonthDetailBus) {
        if (CommonFunctions.hasGuidValue(data.inventoryCostAdjustmentId)) {
            this.svc_data.inventoryCostAdjustment_Delete(data.inventoryCostAdjustmentId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    this.selectedData.adjustedQuantity = null;
                    this.selectedData.reason = null;
                    this.selectedData.inventoryCostAdjustmentId = null;
                    this.selectedData.orderReceiveDetailId = null;
                    this.notify("Adjustment Successfully Removed!");                }
                else {
                    this.deleteError(data, dataObj.message);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    //getData() {
    //    this.dataLoading = true;
    //    let search: DispatchSearch = new DispatchSearch();

    //    search.customerId = this.selected_customer.value;
    //    search.locationId = (this.selected_location !== undefined && this.sloweselected_location !== null) ? this.selected_location.value : "";
    //    search.openStatusesOnly = this.openStatusesOnly;
    //    search.type = DispatchSearchType.all;
    //    if (this.selected_type_value === "S") {
    //        search.type = DispatchSearchType.service;
    //    }
    //    else if (this.selected_type_value === "C") {
    //        search.type = DispatchSearchType.construction;
    //    }
    //    search.skip = this.skip;
    //    search.note = this.search_note;
    //    CommonFunctions.unsubscribe(this.subs_data);
    //
    //    this.subs_data = this.svc_data.GetDispatchBySearch(search).subscribe(data => {
    //        this.ListData = data;
    //
    //        this.dataLoading = false;;
    //        this.getLogo(this.selected_customer.value);
    //    });
    //}

}
